import { gql } from '@apollo/client'
import { DTVFragment } from '../fragments/dtv.fragments'
import { getChildElementQuery } from './projectElements.queries'

export const GetContentInsertStatusQuery = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
        query getContentInsertStatus(
            $instanceId: String!,
            $partType: TemplateItemPartType!,
            $rootArticleContentItemIds: [String],
            $productFamilyId: String!) {
            getContentInsertStatus(input: {instanceId: $instanceId}) {
                state
                progressPercentage
                errorMessage
                updatedProjectContent {
                    documentTemplateView {
                        ...dtvFragment
                    }
                    projectNuggets {
                        id
                        projectProductTypeProperties {
                            id
                            name
                        }
                        projectElementMetadata {
                            baseElementId
                        }
                    }
                    contentItemNodes (input: {
                        templateItemPartType: $partType,
                        rootArticleContentItemId: $rootArticleContentItemIds
                        productFamilyId: $productFamilyId
                    }) {
                        id
                        comments
                        textType
                        ${elements}
                    }
                }
            }
        }
        ${DTVFragment}
    `
}

export const GetProductTypeContentInsertStatusQuery = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
        query getContentInsertStatus(
            $instanceId: String!,
            $partType: TemplateItemPartType!,
            $rootArticleContentItemIds: [String],
            $productFamilyId: String!,
            $nodeId: String!) {
            getContentInsertStatus(input: {instanceId: $instanceId}) {
                state
                progressPercentage
                errorMessage
                updatedProjectContent {
                    projectNuggets {
                        id
                        projectProductTypeProperties {
                            id
                            name
                        }
                        projectElementMetadata {
                            baseElementId
                        }
                        projectProductTypePropertiesView(nodeId: $nodeId) {
                            ...dtvFragment
                        }
                    }
                    contentItemNodes (input: {
                        templateItemPartType: $partType,
                        rootArticleContentItemId: $rootArticleContentItemIds
                        productFamilyId: $productFamilyId
                    }) {
                        id
                        comments
                        textType
                        ${elements}
                    }
                }
            }
        }
        ${DTVFragment}
    `
}
